import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import moment from 'moment';
import Loading from '@/components/Form/Loading';
import { FormError } from 'UIKit/Fonts';
import { Flex, Box } from 'UIKit/Grid';
import {
  fetchOlimpic,
  fetchOlimpicParticipations,
  REQUEST_GET_OLIMPIC_PARTICIPATIONS,
} from '@/modules/Olimpic';

import { ROLE } from '@/modules/User';
import StyledButton from 'sama_global/components/StyledButton';
import Table from 'sama_global/components/Table';

const { ADMIN, TEACHER } = ROLE;

const DATE_FORMAT = 'DD.MM.YYYY';

const renderPlace = (value, intl) => {
  if (+value === 0) {
    return intl.formatMessage({ id: 'CHAMPION' });
  }
  if (+value > 3) {
    return intl.formatMessage({ id: 'COMPETITOR' });
  }
  return `${value} ${intl.formatMessage({ id: 'PLACE' })}`;
};

const tableStorageName = 'diploms_table';

const Diplomas = ({
  user,
  getParticipations,
  requests,
  intl,
  // olimpic,
  olimpics,
  getOlimpics,
}) => {
  // const history = useHistory();
  // if (!(user.role === ROLE.ADMIN || olimpic.show_diploms)) {
  //   history.push('/olimpic/about');
  // }

  useEffect(
    () => () => {
      localStorage.removeItem(tableStorageName);
    },
    []
  );

  useEffect(() => {
    getParticipations();
    getOlimpics();
  }, []);
  const request = requests[REQUEST_GET_OLIMPIC_PARTICIPATIONS];

  const columns = [
    {
      name: '_id',
      label: '',
      options: {
        filter: false,
        searchable: false,
        display: 'excluded',
        sort: false,
      },
    },
    {
      name: 'olimpic',
      label: intl.formatMessage({ id: 'OLIMPIC_TITLE' }),
      options: {
        filter: true,
        sort: true,
        sortThirdClickReset: true,
        customBodyRender: value => {
          if (olimpics) {
            const ol = olimpics.find(item => item._id === value);
            return ol && moment(ol.start).format(DATE_FORMAT);
          }
          return '';
        },
      },
    },
    {
      name: 'category',
      label: intl.formatMessage({ id: 'CATEGORY' }),
      options: {
        filter: true,
        sort: true,
        sortThirdClickReset: true,
      },
    },
    {
      name: 'place',
      label: intl.formatMessage({ id: 'PLACE' }),
      options: {
        filter: true,
        sort: true,
        sortThirdClickReset: true,
        customBodyRender: value => renderPlace(value, intl),
      },
    },
    {
      name: '_id',
      label: intl.formatMessage({ id: 'ACTIONS' }),
      options: {
        filter: false,
        searchable: false,
        sort: false,
        customBodyRender: value => (
          <Flex>
            <StyledButton
              variant="contained"
              component={Link}
              to={`/olimpic/diploma/personal/${value}/en`}
            >
              <FormattedMessage id="DIPLOM_EN" defaultMessage="" />
            </StyledButton>
          </Flex>
        ),
      },
    },
  ];

  const params = {
    footerButtons: (
      <>
        {user && (user.role === ADMIN || user.role === TEACHER) && (
          <Flex>
            <Box mr={4}>
              <StyledButton component={Link} to="/olimpic/diploma/center">
                <FormattedMessage id="DIPLOM_FOR_CENTER" defaultMessage="" />
              </StyledButton>
            </Box>
            <StyledButton component={Link} to="/olimpic/diploma/teacher">
              <FormattedMessage id="DIPLOM_FOR_TEACHER" defaultMessage="" />
            </StyledButton>
          </Flex>
        )}
      </>
    ),
  };

  const options = {
    storageKey: tableStorageName,
    download: false,
    print: false,
    viewColumns: false,
    pagination: false,
    selectableRowsHideCheckboxes: true,
  };

  return (
    <Box>
      {request && (
        <>
          {request.loading && <Loading />}
          {request.error && <FormError>{request.errorMessage}</FormError>}

          {request.data && (
            <Table
              title="DIPLOMAS"
              data={request.data.filter(item => item.place != null)}
              columns={columns}
              options={options}
              params={params}
            />
          )}
        </>
      )}
    </Box>
  );
};

Diplomas.propTypes = {
  getParticipations: PropTypes.func.isRequired,
  getOlimpics: PropTypes.func.isRequired,
  requests: PropTypes.object.isRequired,
  intl: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  // olimpic: PropTypes.array.isRequired,
  olimpics: PropTypes.array.isRequired,
};

const mapStateToProps = state => ({
  user: state.user,
  requests: state.requests,
  olimpic: state.olimpic.online,
  olimpics: state.olimpic.olimpic,
});

const mapDispatchToProps = dispatch => ({
  getParticipations() {
    dispatch(fetchOlimpicParticipations());
  },
  getOlimpics() {
    dispatch(fetchOlimpic());
  },
});

/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(Diplomas));
